<h2 mat-dialog-title>{{ 'QUERY_DUPLICATE' | transloco }}</h2>
<mat-dialog-content>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ 'QUERY_DUPLICATE_NAME' | transloco }}</mat-label>
    <input matInput [formControl]="nameControl" />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="null">{{ 'CANCEL' | transloco }}</button>
  <button mat-flat-button color="primary" [disabled]="nameControl.invalid" (click)="confirm()">
    {{ 'QUERY_DUPLICATE' | transloco }}
  </button>
</mat-dialog-actions>
